import React from 'react';

import './DefaultedText.scss';

interface DefaultedTextProps {
  val: string | undefined;
  html?: boolean;
  block?: boolean;
  def?: string;
}

export function DefaultedText(props: DefaultedTextProps) {
  if (!props.val || props.val.length === 0) {
    return <span className="text-smoke italic">{props.def || 'None'}</span>;
  }

  if (props.block) {
    if (props.html) {
      return <div className="defaulted-text" dangerouslySetInnerHTML={{ __html: props.val }}></div>;
    } else {
      return <div>{props.val}</div>;
    }
  }

  if (props.html) {
    return <span className="defaulted-text" dangerouslySetInnerHTML={{ __html: props.val }}></span>;
  }

  return <span>{props.val}</span>;
}
